export const maskDate = (dateItem: string | number | Date) =>
  Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
  }).format(new Date(dateItem));
